import { apiSlice } from "../../apiSlice";
export const ingepropApiSlice = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getDataGraphic: builder.mutation({
      query: (parameters) => ({
        url: `/Financix/Graphics/Ingeprop`,
        method: "GET",
        params: { ...parameters },
        headers: { modulecima: "financix" },
      }),
    }),
    generateExcel: builder.mutation({
      query: (parameters) => ({
        url: `/Financix/Graphics/Ingeprop/generateExcel`,
        method: "GET",
        params: { ...parameters },
        headers: { modulecima: "financix" },
      }),
    }),
    getDataGroups: builder.mutation({
      query: (parameters) => ({
        url: `/Financix/Graphics/Ingeprop/getDataGroups`,
        method: "GET",
        params: { ...parameters },
        headers: { modulecima: "financix" },
      }),
    }),
    getCliReport: builder.mutation({
      query: (parameters) => ({
        url: `/Financix/Graphics/Ingeprop/clients`,
        method: "GET",
        params: { ...parameters },
        headers: { modulecima: "financix" },
      }),
    }),
    getExecReport: builder.mutation({
      query: (parameters) => ({
        url: `/Financix/Graphics/Ingeprop/executive`,
        method: "GET",
        params: { ...parameters },
        headers: { modulecima: "financix" },
      }),
    }),
    getExecAlerts: builder.mutation({
      query: (parameters) => ({
        url: `/Financix/Graphics/Ingeprop/executive/alerts`,
        method: "GET",
        params: { ...parameters },
        headers: { modulecima: "financix" },
      }),
    }),
    getExecAlertsSlow: builder.mutation({
      query: (parameters) => ({
        url: `/Financix/Graphics/Ingeprop/executive/alerts/slow`,
        method: "GET",
        params: { ...parameters },
        headers: { modulecima: "financix" },
      }),
    }),
    getExecMovement: builder.mutation({
      query: (parameters) => ({
        url: `/Financix/Graphics/Ingeprop/executive/movement`,
        method: "GET",
        params: { ...parameters },
        headers: { modulecima: "financix" },
      }),
    }),
    getCliKpiItems: builder.mutation({
      query: (parameters) => ({
        url: `/Financix/Graphics/Ingeprop/clients/kpi/items`,
        method: "GET",
        params: { ...parameters },
        headers: { modulecima: "financix" },
      }),
    }),
    getCliKpiDeclaraciones: builder.mutation({
      query: (parameters) => ({
        url: `/Financix/Graphics/Ingeprop/clients/kpi/declaraciones`,
        method: "GET",
        params: { ...parameters },
        headers: { modulecima: "financix" },
      }),
    }),
    getCliKpiInspAuto: builder.mutation({
      query: (parameters) => ({
        url: `/Financix/Graphics/Ingeprop/clients/kpi/insp-auto`,
        method: "GET",
        params: { ...parameters },
        headers: { modulecima: "financix" },
      }),
    }),
    getCliKpiInspFis: builder.mutation({
      query: (parameters) => ({
        url: `/Financix/Graphics/Ingeprop/clients/kpi/insp-fis`,
        method: "GET",
        params: { ...parameters },
        headers: { modulecima: "financix" },
      }),
    }),
    getCliKpiInspDoc: builder.mutation({
      query: (parameters) => ({
        url: `/Financix/Graphics/Ingeprop/clients/kpi/insp-doc`,
        method: "GET",
        params: { ...parameters },
        headers: { modulecima: "financix" },
      }),
    }),
    getCliKpis: builder.mutation({
      query: (parameters) => ({
        url: `/Financix/Graphics/Ingeprop/clikpis`,
        method: "GET",
        params: { ...parameters },
        headers: { modulecima: "financix" },
      }),
    }),
    generateConsolidadoExcel: builder.mutation({
      query: (parameters) => ({
        url: `/Financix/Graphics/Ingeprop/generateConsolidado`,
        method: "GET",
        params: { ...parameters },
        headers: { modulecima: "financix" },
      }),
    }),
    generateEjecutivoExcel: builder.mutation({
      query: (parameters) => ({
        url: `/Financix/Graphics/Ingeprop/generateEjecutivo`,
        method: "GET",
        params: { ...parameters },
        headers: { modulecima: "financix" },
      }),
    }),
  }),
});

export const {
  useGetDataGraphicMutation,
  useGenerateExcelMutation,
  useGetDataGroupsMutation,
  useGetCliReportMutation,
  useGetCliKpiItemsMutation,
  useGetCliKpiDeclaracionesMutation,
  useGetCliKpiInspAutoMutation,
  useGetCliKpiInspFisMutation,
  useGetCliKpiInspDocMutation,
  useGetExecReportMutation,
  useGetExecAlertsMutation,
  useGetExecAlertsSlowMutation,
  useGetExecMovementMutation,
  useGetCliKpisMutation,
  useGenerateConsolidadoExcelMutation,
  useGenerateEjecutivoExcelMutation,
} = ingepropApiSlice;
